








import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class PeriodBar extends Vue {
  @Prop()
  periods: number[][] | undefined;

  get allPeriods(): number[] {
    return _.flatten(this.periods);
  }
}
